<template>
  <div>
    <div class="dropdown-profile" v-if="isLogin">
        <b-dropdown id="dropdown-profile-setting">
            <template #button-content>
                <img v-if="profileImagePath" class="profile-image" :src="profileImagePath"/>
                <img v-else class="profile-image" src="../../../../assets/icon/user-profile.png"/>
                <span class="name">{{fullName}}</span>
                <img class="ic-dropdown-image" src="../../../../assets/new/icon/ic-dropdown-profile-setting.png"/>
            </template>
            <b-dropdown-item>
                <div class="item" @click="goToProfile()">
                    <img class="mr-4 w-6 h-6" src="@/assets/icon/ic-profile.svg" />
                    {{ lbl.side_menu.profile }}
                </div>
            </b-dropdown-item>
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item>
                <div class="item logout" @click="clickLogout()">
                    <img class="mr-4 w-6 h-6" src="@/assets/new/icon/ic-logout.png" />
                    {{ lbl.side_menu.logout }}
                </div>
            </b-dropdown-item>
        </b-dropdown>
    </div>
    <div class="dropdown-profile" v-else>
        <b-dropdown id="dropdown-profile-setting">
            <template #button-content>
                <img class="profile-image" src="../../../../assets/icon/user-profile.png" @click="goLogin()"/>
            </template>
        </b-dropdown>
    </div>
    <modal-master :controller="modalController"></modal-master>
  </div>
</template>

<script>
// mixin
import ModalMixin from '@/mixin/ModalMixin';
import LocaleMixin from '@/mixin/LocaleMixin';
import AccountMixin from '@/mixin/AccountMixin';
// helper
import Account from '@/helper/AccountHelper.js';
import ConfigManager from '@/config/ConfigManager.js';
import CacheHelper from '@/helper/CacheHelper';
export default {
    name: 'ButtonDropdown',
    mixins:[ModalMixin,LocaleMixin,AccountMixin],
    data: function() {
        return {
            showList: false,
            profileImagePath: '',
            formData: {},
            modalController: null,
            logoutModal: null,
            appId: null,
            profilename : '',
        }
    },
    created: function() {
        this.accountInitiated()
    },
    computed: {
        fullName() {
            let string = `${this.formData.firstName} ${this.formData.lastName}`
            if(string.length > 13) {
                string = `${string.substring(0,13)}...`
            }
            return string
        }
    },
    methods: {
        accountInitiated: async function () {
            if (this.isLogin) {
                this.profileImagePath = this.getUrlProfileImage();
                let data = await Account.apiGetProfile();
                this.formData = data.profile;

                var cacheHelper = new CacheHelper();
                var cache = cacheHelper.getCache('BzbsUser');
                this.appId = cache.appId
                this.profilename = `${this.formData.firstName} ${this.formData.lastName}`;
            }
        },
        clickDropdown: function() {
            this.showList = !this.showList
        },
        goToProfile: function() {
            this.$route.path !== '/main/myprofile' && this.$router.push('/main/myprofile')
        },
        getUrlProfileImage: function() {
            const userId = Account.getCacheUser().userId;
            const token = Account.getToken();
            const currentTime = new Date().getTime();
            var imageUrl = ConfigManager.getApiUrl() + `/profile/${userId}/picture?type=large&token=${token}&time=${currentTime}`;
            return imageUrl;
        },
        clickLogout: function () {
            this.logoutModal
                .clearModal()
                .setTitle(this.lbl.logout_popup.title)
                .setMsg(this.lbl.logout_popup.msg)
                .setBtnCancel(this.lbl.logout_popup.btnCancel)
                .setBtnOk(this.lbl.logout_popup.btnOk)
                .show()
            this.logoutModal.onClickOk(() => {
                var cacheHelper = new CacheHelper(ConfigManager.getCacheType());
                cacheHelper.removeCache('BzbsUser');
                this.$nextTick(() => {
                    this.$router.push({ path: '/login', query: { app_id: this.appId } })
                })
            })
        },
        goLogin: function() {
            this.confirmModal
                .clearModal()
                .setTitle(this.lbl.alert_popup.login.title)
                .setMsg(this.lbl.alert_popup.login.msg)
                .setBtnOk(this.lbl.alert_popup.login.btnOk)
                .setBtnCancel(this.lbl.alert_popup.login.btnCancel)
                .show();
            this.confirmModal.onClickOk(() => {
                this.$router.push('/login')
            })
        }
    },
}
</script>
<style lang="scss">
    .dropdown-profile {
        max-width: 200px;
    }
    #dropdown-profile-setting {

        ul.dropdown-menu.show {
            top: 6px !important;
            border-radius: 8px;
            box-shadow: 0 3px 5px 0 rgba(0, 0, 0, 0.16);
            background-color: #fff;
        }
        a.dropdown-item {
            padding: 20px;
        }
        .dropdown-item:hover, .dropdown-item:focus{
            border-radius: 8px;
        }
        .dropdown-menu{
            padding: 0;
        }
        .dropdown-divider{
            margin: 0;
        }
        .btn-secondary {
            background-color: #fff !important;
            border-radius: 8px;
            border: solid 1px #fff !important;
        }

        .dropdown-toggle::after {
            display: none;
        }
    }

</style>
<style lang="scss" scoped>
    @import "@/style/base/base.scss";
    @import "./ButtonDropdown.scss";
</style>
